import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/nfts/verified2.svg'


const _hoisted_1 = {
  class: "trezo-card",
  id: "featuredNftArtworksSlides"
}
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "bg-white dark:bg-[#0c1427] p-[10px] rounded-md" }
const _hoisted_4 = { class: "flex items-center justify-between border-b border-primary-50 dark:border-[#172036] pb-[10px] mb-[14px]" }
const _hoisted_5 = { class: "flex items-center gap-[6px]" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "block text-xs" }
const _hoisted_8 = { class: "block text-xs mb-[4px]" }
const _hoisted_9 = { class: "font-semibold text-gray-900 dark:text-gray-400 ltr:ml-[2px] rtl:mr-[2px]" }
const _hoisted_10 = { class: "flex items-center justify-between pb-[5px]" }
const _hoisted_11 = { class: "block font-semibold text-primary-800" }
const _hoisted_12 = { class: "block relative text-xs font-semibold ltr:pl-[22px] rtl:pr-[22px]" }
const _hoisted_13 = { class: "text-gray-900 dark:text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"trezo-card-header mb-[20px] flex items-center justify-between\"><div class=\"trezo-card-title\"><h5 class=\"mb-0\">Featured NFT Artworks</h5></div><div class=\"trezo-card-subtitle flex items-center gap-[10px]\"><div class=\"swiper-button-prev relative top-0 mt-0 inline-block w-[30px] h-[30px] rounded-full border border-gray-500 dark:border-[#172036] text-gray-500 dark:text-gray-400 leading-[28px] text-lg left-0 right-0 text-center transition-all hover:bg-dark hover:text-white hover:border-dark\"><i class=\"ri-arrow-left-line\"></i></div><div class=\"swiper-button-next relative top-0 mt-0 inline-block w-[30px] h-[30px] rounded-full border border-gray-500 dark:border-[#172036] text-gray-500 dark:text-gray-400 leading-[28px] text-lg left-0 right-0 text-center transition-all hover:bg-dark hover:text-white hover:border-dark\"><i class=\"ri-arrow-right-line\"></i></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Swiper, {
        spaceBetween: 25,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 3,
          },
        },
        modules: _ctx.modules,
        class: "mySwiper2"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nftItem, (nft) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: nft.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "h-[172px] rounded-md bg-center bg-cover bg-no-repeat mb-[12px]",
                    style: _normalizeStyle({ backgroundImage: `url(${nft.image})` })
                  }, null, 4),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("img", {
                        src: nft.creator.image,
                        class: "rounded-full w-[27px]",
                        alt: "author-image"
                      }, null, 8, _hoisted_6),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_7, " NFT ID: " + _toDisplayString(nft.creator.id), 1),
                        _createVNode(_component_RouterLink, {
                          to: "/nft-marketplace/nft-details",
                          class: "block font-semibold text-gray-900 dark:text-gray-400 transition-all hover:text-primary-500"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(nft.creator.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]),
                    _cache[0] || (_cache[0] = _createElementVNode("img", {
                      src: _imports_0,
                      alt: "verified"
                    }, null, -1))
                  ]),
                  _createElementVNode("span", _hoisted_8, [
                    _cache[1] || (_cache[1] = _createTextVNode(" Highest Bid: ")),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(nft.highestBid) + " ETH ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(nft.bid) + " ETH ", 1),
                    _createElementVNode("span", _hoisted_12, [
                      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ri-heart-fill text-orange-600 absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 text-lg" }, null, -1)),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(nft.rating) + "/", 1),
                      _cache[3] || (_cache[3] = _createTextVNode("10 "))
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"])
    ])
  ]))
}